/* LUKACHARI: the "points on this purchase" line on product pages (21.09.2026).
   Rivo's block rendered 148 for a 150 ILS item. We show: selected variant price x quantity (1 point per 1 ILS, base tier).
   Prices come from window.lkVariantPrices (printed by layout/theme.liquid), so it also works in the theme editor.
   Members in higher tiers earn more (multiplier applied by Rivo at order time). */
(function(){
  function mainQty(){ return document.querySelector('input[name="quantity"][form]'); }
  function points(){
    var prices=window.lkVariantPrices||{};
    var qEl=mainQty();
    var f=(qEl&&qEl.form)||document.querySelector('form.shopify-product-form')||document.querySelector('form[action*="/cart/add"]');
    var idEl=f&&f.elements&&f.elements.namedItem('id');
    if(idEl&&idEl.length&&!idEl.value) idEl=idEl[0];
    var id=(idEl&&idEl.value)||window.lkDefaultVariant;
    var price=prices[id]; if(price==null) price=prices[window.lkDefaultVariant];
    if(price==null) return null;
    var q=parseInt(qEl&&qEl.value,10); if(!(q>0)) q=1;
    return Math.floor(Number(price)/100)*q;
  }
  function fix(){
    var p=points(); if(p==null||!(p>0)) return;
    var s=String(p);
    var els=document.querySelectorAll('.order-placed-potential-points-amount');
    for(var i=0;i<els.length;i++){ if(els[i].textContent!==s) els[i].textContent=s; }
  }
  function start(){
    fix();
    ['change','input','click','keyup'].forEach(function(ev){ document.addEventListener(ev,function(){ setTimeout(fix,60); },true); });
    setInterval(fix,500);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
